import AttachmentSecNavBar from '@src/components/navigationBar/secondary/AttachmentSecNavBar'
import OrbitalTrackDetail from '@src/components/orbitalTrack/detail/OrbitalTrackDetail'
import { OrbitalTrackAttachProvider } from '@src/contexts/orbitalTrack/OrbitalTrackAttachContext'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import type { NextPage } from 'next'
import { useEffect } from 'react'

const OrbitalTrackPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<AttachmentSecNavBar index={1} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <OrbitalTrackAttachProvider>
      <OrbitalTrackDetail />
    </OrbitalTrackAttachProvider>
  )
}

type Props = {}

export default OrbitalTrackPage
